
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { FeedbackFormValues } from './schema';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';

interface CandidateInfoTabProps {
  form: UseFormReturn<FeedbackFormValues>;
  isReadOnly?: boolean;
  contextLabels?: {
    candidateLabel: string;
    positionLabel: string;
  };
}

const CandidateInfoTab: React.FC<CandidateInfoTabProps> = ({ 
  form, 
  isReadOnly = false,
  contextLabels = { candidateLabel: 'Candidat', positionLabel: 'Intitulé du poste' }
}) => {
  return (
    <div className="space-y-4">
      <FormField
        control={form.control}
        name="candidateName"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Nom du {contextLabels.candidateLabel}</FormLabel>
            <FormControl>
              <Input placeholder={`Prénom et nom du ${contextLabels.candidateLabel.toLowerCase()}`} {...field} readOnly={isReadOnly} />
            </FormControl>
            <FormDescription>
              Le nom complet du {contextLabels.candidateLabel.toLowerCase()}
            </FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="candidateEmail"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Email du {contextLabels.candidateLabel} (optionnel)</FormLabel>
            <FormControl>
              <Input type="email" placeholder="email@example.com" {...field} readOnly={isReadOnly} />
            </FormControl>
            <FormDescription>
              L'adresse email du {contextLabels.candidateLabel.toLowerCase()} (si disponible)
            </FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="jobTitle"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{contextLabels.positionLabel}</FormLabel>
            <FormControl>
              <Input placeholder={`ex: ${contextLabels.positionLabel === 'Intitulé du poste' ? 'Développeur Full Stack' : 'Projet de refonte site web'}`} {...field} readOnly={isReadOnly} />
            </FormControl>
            <FormDescription>
              {contextLabels.positionLabel} concerné par le feedback
            </FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};

export default CandidateInfoTab;
